<template>
  <ts-loading-banner :loading="waiting">
    <div class="ts-space-y-4">
      <div class="row form-group">
        <label class="required col-form-label col-md-12">{{
          $t('chat.classRoom')
        }}</label>
        <div class="col-md-12">
          <div class="ts-w-64 ts-mb-1">
            <a-radio-group
              v-model="acStatusId"
              size="small"
              @change="acStatusChange()"
            >
              <a-radio-button :value="1">
                {{ $t('studentScoringEntry.current') }}
              </a-radio-button>
              <a-radio-button :value="2">
                {{ $t('studentScoringEntry.history') }}
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div class="col-md-12">
          <a-select
            v-model="model.class_id"
            style="width: 100%; height: 35px"
            :show-search="true"
            option-filter-prop="children"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            :class="{ 'is-invalid': errors.has('class_id') }"
            @change="getUsers()"
          >
            <a-select-option
              v-for="(classRoom, index) in classRooms"
              :key="index"
              :value="classRoom.class_id"
            >
              {{ classRoom.class_name }}
              {{ classRoom.students ? getStudentName(classRoom.students) : '' }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
      </div>

      <div class="row form-group" v-if="isStaff">
        <label class="required col-form-label col-md-12">{{
          $t('chat.user')
        }}</label>
        <div class="col-md-12">
          <a-select
            v-model="model.receiver_id"
            style="width: 100%; height: 35px"
            :show-search="true"
            option-filter-prop="children"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            :class="{
              'is-invalid': errors.has('receiver_id')
            }"
            @change="onUserChange()"
          >
            <a-select-option
              v-for="(user, index) in users"
              :key="index"
              :value="user.user_id"
            >
              {{ user.full_name }}
              {{
                user.activated_type == 'Student'
                  ? '(' + user.activated_type + ')'
                  : '(' + user.guardian_type_name + ')'
              }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('receiver_id')">
            {{ errors.first('receiver_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label class="required col-form-label col-md-12">{{
          $t('chat.message')
        }}</label>
        <div class="col-md-12">
          <textarea
            v-model="model.comments"
            rows="4"
            class="form-control"
            :class="{
              'is-invalid': errors.has('comments')
            }"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('comments')">
            {{ errors.first('comments') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button color="primary" @click.prevent="onSave">{{
            $t('save')
          }}</ts-button>
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
// import {  } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'newChatform',
  // props: ['value'],
  data () {
    return {
      waiting: false,
      loading: false,
      errors: new Errors(),
      search: '',
      users: [],
      classRooms: [],
      model: {
        acps_id: null,
        class_id: null,
        receiver_id: null,
        receiver_activated_type_id: null,
        receiver_guardian_type: null,
        comments: null
      }
    }
  },
  created () {
    this.getClassRooms()
  },
  computed: {
    isStaff () {
      return this.$store.getters.isStaffLogin
    },
    acStatusId: {
      get () {
        return this.$store.state.parentCommunicationChat.ac_status_id
      },
      set (newValue) {
        this.$store.commit('parentCommunicationChat/SET_AC_STATUS', newValue)
      }
    }
  },
  methods: {
    acStatusChange () {
      this.model.class_id = null
      this.model.acps_id = null
      this.getClassRooms()
    },
    onUserChange () {
      let receiver = this.users.find(el => el.user_id == this.model.receiver_id)
      this.model.receiver_id = receiver.user_id
      this.model.receiver_activated_type_id = receiver.activated_type_id
      this.model.receiver_guardian_type = receiver.guardian_type
    },
    getClassRooms () {
      this.waiting = true
      this.$store
        .dispatch('parentCommunicationChat/getClassRoom')
        .then(response => {
          this.waiting = false
          this.classRooms = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    getUsers () {
      this.loading = true
      this.model.acps_id = this.classRooms.find(
        el => el.class_id == this.model.class_id
      ).acps_id
      this.$store
        .dispatch('parentCommunicationChat/getUser', {
          class_id: this.model.class_id
        })
        .then(response => {
          this.loading = false
          this.users = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getStudentName (student) {
      let name = ''
      student.map(el => (name = name + el.full_name_en))
      return name
    },
    onSave () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch(
          'parentCommunicationChat/storeChatGroup',
          Object.assign({}, this.model)
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>

<style scoped>
.max-h {
  height: 400px;
  max-height: 500px;
  overflow: scroll;
}
</style>
